import React, { useEffect, useState } from "react";
import { Container, Text, Title, Paper, Loader, Button } from "@mantine/core";
import { useStore } from "../store";
import { confirmAddon, getTenantProfile } from "../api";

function PaymentSuccess() {
  const setTenantProfile = useStore((state) => state.setTenantProfile);
  const [isLoading, setIsLoading] = useState(true);

  function sleeper(ms) {
    return function (x) {
      return new Promise((resolve) => setTimeout(() => resolve(x), ms));
    };
  }

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get("session_id");

    const settle = async () => {
      if (sessionId) {
        try {
          await confirmAddon(sessionId);
        } catch (err) {
          console.error("Add-on confirm failed", err);
        }
      } else {
        await sleeper(2000)();
      }

      const data = await getTenantProfile();
      setTenantProfile(data);
      setIsLoading(false);
    };

    settle();
  }, []);

  return (
    <Container size="sm" ta="center">
      <Paper mt="xl" p="lg" withBorder>
        <Title mb="md" order={2}>
          Payment Successful
        </Title>

        {isLoading ? (
          <>
            <Loader />
            <Text>Thanks! Your payment is on the way.</Text>
          </>
        ) : (
          <div>
            <Text>Your profile should reflect the changes now.</Text>
            <Button component="a" href="/settings/tenant" mt="lg">
              Proceed
            </Button>
          </div>
        )}
      </Paper>
    </Container>
  );
}

export default PaymentSuccess;
